module.exports = __webpack_public_path__ + "img/链上监控脚本.ce45c900.png";